import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../../resources/ResourcesStore";
import type { StudyInUpload } from "../../../StudyInUpload";
import { RichToolTipComponent } from "../../../../shared-components/rich-tooltip/RichToolTipComponent";
import type { PatientToUpload } from "../../../PatientToUpload";
import { StaticNotificationComponent } from "../../../../shared-components/static-notification/StaticNotificationComponent";
import { NonDicomFileComponent } from "../non-dicom-files/NonDicomFileComponent";
import { injectFromAppUpload } from "../../../inject";
import { DobTextarea } from "@dedalusdiit/dob-components";
import { notNullOrUndefined } from "../../../../util/functions/notNullOrUndefined";

interface IStudyInUploadComponent {
    resourcesStore?: IResourcesStore;
    studyInUpload: StudyInUpload;
    patientToUpload: PatientToUpload;
    canBeRemoved: boolean;
}

@injectFromAppUpload<IStudyInUploadComponent>(stores => ({
    resourcesStore: stores.resourcesStore,
}))
@observer
export class StudyInUploadComponent extends React.Component<IStudyInUploadComponent> {
    removeStudyInUpload = (event): void => {
        event.stopPropagation();
        const { studyInUpload, patientToUpload } = this.props;
        patientToUpload.removeStudyInUpload(studyInUpload);
    };

    onCommentChange = (value: string): void => {
        if (notNullOrUndefined(value)) {
            this.props.studyInUpload.setComment(value);
        }
    };

    render() {
        const { resourcesStore, studyInUpload, canBeRemoved } = this.props;
        const { resources } = resourcesStore!;
        const { modality, studyDescription, accessionNumber, studyDateFormatted, studyTimeFormatted, dicomFiles, nonDicomFiles, comment } = studyInUpload;

        return (
            <StaticNotificationComponent title={modality + " " + studyDescription} hideIcon={true} customClass={"study-to-upload-container label-value-containers-holder"}>
                <div className={"row"}>
                    <div className={"label-value-container"}>
                        <div className={"label-item"}>{resources.StudyDate}</div>
                        <div className={"value-item"}>
                            {studyDateFormatted} {studyTimeFormatted}
                        </div>
                    </div>
                    <div className={"label-value-container"}>
                        <div className={"label-item"}>{resources.AccessionNumber}</div>
                        <div className={"value-item"}>{accessionNumber}</div>
                    </div>
                </div>
                <div className={"label-value-container comment-field"}>
                    <div className={"input-item"}>
                        <DobTextarea maxLength={256} disabled={!canBeRemoved} value={comment ?? ""} placeholder={resources.OptionalComment} onValueChange={this.onCommentChange} />
                    </div>
                </div>

                <div className={"study-files-info-container"}>
                    <p>
                        <span>{resources.XDICOMFiles.replace("{0}", dicomFiles.length.toString())}</span> -{" "}
                        <span>{resources.XNonDICOMFiles.replace("{0}", nonDicomFiles.length.toString())}</span>
                    </p>
                    <div className={"files-to-arrange-container"}>
                        {nonDicomFiles.length > 0 && nonDicomFiles.map(f => <NonDicomFileComponent file={f} key={f.fileGuid} canBeRemoved={canBeRemoved} />)}
                    </div>
                </div>

                {canBeRemoved && (
                    <RichToolTipComponent toolTipResource={"RemoveStudy"} className={"remove-study"} onClick={this.removeStudyInUpload}>
                        &nbsp;
                    </RichToolTipComponent>
                )}
            </StaticNotificationComponent>
        );
    }
}
